// import Login from './pages/login';
// import './App.css';
// import './css/bootstrap.min.css'
// import './css/style.css'
//import './css/fontawesome-all.min.css'
// import './css/animate.css'
import "./assets/css/style-starter.css";
import "./assets/css/popup.css";
import "./assets/css/typography.css";
import "./assets/css/ui-styles.css";

import Routes from "./routes";
import ReactGA from "react-ga4";
import { useEffect } from "react";

const App = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === "production") {
      ReactGA.initialize("G-9N2CD6FM7V");
    }
  }, []);

  return <Routes />;
};

export default App;
